import { alpha } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

export const getCourseGlassSurfaceSx = (theme: Theme, intensity: "soft" | "strong" = "soft"): SystemStyleObject<Theme> => {
  const contrastAlpha = intensity === "strong" ? 0.055 : 0.04;
  const infoAlpha = intensity === "strong" ? 0.12 : 0.08;

  return {
    borderRadius: 0,
    border: `1px solid ${alpha(theme.palette.primary.contrastText, 0.095)}`,
    background: `linear-gradient(145deg, ${alpha(theme.palette.primary.contrastText, contrastAlpha)} 0%, ${alpha(
      theme.palette.info.dark,
      infoAlpha,
    )} 100%)`,
    backdropFilter: "blur(14px)",
    boxShadow: `0 16px 42px ${alpha(theme.palette.primary.dark, 0.14)}`,
  };
};

export const getCourseMediaFrameSx = (theme: Theme): SystemStyleObject<Theme> => ({
  borderRadius: 0,
  border: `1px solid ${alpha(theme.palette.primary.contrastText, 0.08)}`,
});
